export const getChapterId = (chapter) =>
  chapter?.chapter_id ?? chapter?.id ?? chapter?.pivot?.chapter_id;

export const getChapterQuestionCount = (chapter) =>
  chapter?.no_of_questions ?? chapter?.pivot?.no_of_questions ?? 0;

export const getChapterType = (chapter) =>
  chapter?.type ?? chapter?.pivot?.type ?? 0;

export const getDisplayChapter = (chapters = []) => {
  if (!chapters?.length) return undefined;
  return (
    chapters.find((chapter) => Number(getChapterQuestionCount(chapter)) === 0) ||
    chapters.find((chapter) => Number(chapter.active) === 1) ||
    chapters[0]
  );
};

export const getWalletChapters = (chapters = []) =>
  (chapters || []).filter(
    (chapter) => Number(getChapterQuestionCount(chapter)) !== 0
  );
